import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { Info } from "lucide-react";

export const GeneralFilterAlert = () => {
  return (
    <Flex
      data-testid="general-filter-alert"
      alignItems="center"
      justifyContent="space-between"
      bgColor={AppColors.LIGHT_BLUE_ALT}
      paddingY="20px"
      marginBottom="30px"
      paddingX="30px"
      borderRadius="6px"
      maxHeight="41px"
      css={{
        "@media (max-width: 1350px) and (min-width: 1272px)": {
          maxWidth: "400px",
        },
        "@media (max-width: 1414px) and (min-width: 1351px)": {
          maxWidth: "450px",
        },
        "@media (max-width: 1590px) and (min-width: 1415px)": {
          maxWidth: "500px",
        },
        "@media (max-width: 1696px) and (min-width: 1591px)": {
          maxWidth: "500px",
        },
        "@media (max-width: 1920px)": {
          maxWidth: "500px",
        },
      }}
    >
      <Flex alignItems="center" gap="12px">
        <Info />
        <Text
          css={{
            "@media (max-width: 1350px) and (min-width: 1272px)": {
              fontSize: "12px",
            },
            "@media (max-width: 1414px) and (min-width: 1351px)": {
              fontSize: "14px",
            },
            "@media (max-width: 1590px) and (min-width: 1415px)": {
              fontSize: "14px",
            },
            "@media (max-width: 1696px) and (min-width: 1591px)": {
              fontSize: "14px",
            },
            "@media (max-width: 1920px)": {
              fontSize: "16px",
            },
          }}
          fontWeight={500}
        >
          Seleccione una fecha para filtrar de forma general
        </Text>
      </Flex>
    </Flex>
  );
};
